import { VaccineConfig } from "@ambii-com/core";
import {
  liteCollections,
  liteQueryCollectionLimited,
} from "~/utils/firestoreLite";

export async function readVaccineConfigByClinicId(
  clinicId: string
): Promise<VaccineConfig | undefined> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.vaccineConfigs,
    1,
    ["clinicId", "==", clinicId]
  );
  return VaccineConfig.fromDocs(docs)[0];
}
